module.exports = __webpack_public_path__ + "static/media/customer-dominos.46220c4f.png";